import { useMemo } from "react";
import { usePaginatedParticipants } from "@100mslive/react-sdk";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import { SPECTATORS_PAGE_SIZE } from "../provider/constants";
import type { ProviderSpectators } from "../types";
import { convertHMSPeerToPeer } from "./helpers";

export const useHMSSpectators = (): ProviderSpectators => {
  const {
    peers: hmsPeers,
    loadPeers,
    loadMorePeers,
    hasNext,
    total,
  } = usePaginatedParticipants({
    role: PARTICIPANT_ROLES.HLS_SPECTATOR,
    limit: SPECTATORS_PAGE_SIZE,
  });

  const peers = useMemo(() => hmsPeers.map(convertHMSPeerToPeer), [hmsPeers]);

  return {
    peers,
    loadPeers,
    loadMorePeers,
    hasNext,
    total,
  };
};
